import { render } from "./ProviderAccount.vue?vue&type=template&id=6837336a&scoped=true"
const script = {}

import "./ProviderAccount.vue?vue&type=style&index=0&id=6837336a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6837336a"]])

export default __exports__